import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from "primeng/menubar";
import { SortField } from '../models/sort-field';
import { SortCriteria } from '../models/sort-criteria';
import { SortDirection } from '../enums/sort-direction.enum';
import { PanelHubConstants } from '../constants/panel-hub-constants';

@Component({
  selector: 'app-sort-menu',
  standalone: true,
  imports: [CommonModule, MenubarModule],
  templateUrl: './sort-menu.component.html',
  styleUrls: ['./sort-menu.component.scss']
})
export class SortMenuComponent implements OnInit, OnChanges {
  @Input() sortOptions: SortField[] = [];
  @Input() label: string = PanelHubConstants.DefaultSortLabel;
  @Output() sortChange = new EventEmitter<SortCriteria>();
  sortItems: MenuItem[] = [];

  ngOnInit(): void {
    this.buildMenu();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sortOptions']) {
      this.buildMenu();
    }
  }

  private buildMenu() {
    if (!this.sortOptions?.length) return;

    const items: MenuItem[] = this.sortOptions.map((option) => ({
      label: option.fieldDisplayName,
      items: [
        {
          label: 'Ascending',
          icon: 'pi pi-sort-alpha-up',
          command: () => this.emitSort(option.fieldName, SortDirection.Ascending),
          style: { float: 'left' }
        },
        {
          label: 'Descending',
          icon: 'pi pi-sort-alpha-down-alt',
          command: () => this.emitSort(option.fieldName, SortDirection.Descending),
          style: { float: 'left' }
        },
      ],
      style: { 'margin-left': 'auto' },
    }));

    this.sortItems = [{ label: this.label, items }];
  }

  private emitSort(field: string, direction: SortDirection) {
    this.sortChange.emit({ field: field, sortDirection: direction });
  }
}
